import { Component } from '@angular/core';

@Component({
    selector: 'lib-custom-page-missing',
    templateUrl: './custom-page-missing.component.html',
    styleUrls: ['./custom-page-missing.component.css'],
    standalone: false
})
export class CustomPageMissingComponent { }
